import React from 'react'
import { connect } from 'react-redux'
import { NewsComponent } from '../../components'
import './styles.scss';
import { getBlogPageWithSize } from '../../actions'
import { useEffect } from 'react';

const Blog = ({blogPageWithSize, getBlogPageWithSize, nextPage, loading, error}) => {

  useEffect(() => {
    getBlogPageWithSize({
      page:1,
      size:10
    });
  },[getBlogPageWithSize]);
  
  useEffect(() => {
    window.scrollTo({
      top:0,
      behavior:"smooth"
    });
  },[]);

 
  if (loading && blogPageWithSize.length === 0) {
    return (
      <div className="blog-container">
        <div className="blog-loading">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Зареждане на статии...</p>
          </div>
        </div>
      </div>
    );
  }

  
  if (error && blogPageWithSize.length === 0) {
    return (
      <div className="blog-container">
        <div className="blog-error">
          <div className="error-message">
            <h3>Възникна грешка</h3>
            <p>Не можахме да заредим статиите. Моля, опитайте отново.</p>
            <button 
              onClick={() => {
                getBlogPageWithSize({ page: 1, size: 10 });
              }}
              className="retry-button"
            >
              Опитай отново
            </button>
          </div>
        </div>
      </div>
    );
  }

  return(
    <div className="blog-container">
      <div className="blog-content fade-in">
        <NewsComponent 
          blogPageWithSize={blogPageWithSize} 
          getBlogPageWithSize={getBlogPageWithSize} 
          nextPage={nextPage}
          loading={loading}
          error={error}
        />
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  blogPageWithSize: state.blog.blogPageWithSize,
  nextPage: state.blog.nextPage,
  loading: state.blog.loading,
  error: state.blog.error,
})

const mapDispachToProps = dispatch => ({
  getBlogPageWithSize: payload => dispatch(getBlogPageWithSize(payload)),
})

export default connect(mapStateToProps, mapDispachToProps)(Blog);
